/**
 * PURPOSE: Consumir la matriz bulk de uniformes por evento/deporte.
 * RESPONSIBILITIES: Leer participantes/uniformes y guardar celdas creadas, editadas o eliminadas.
 * COLLABORATORS: UniformMatrix.jsx y backend /uniforms/matrix.
 * ROUTE: winscore/src/services/uniformMatrixService.js
 */
import httpService from "./httpService.js";

export const getUniformMatrix = async ({ idevent, idsport }) => {
  const response = await httpService.get("/uniforms/matrix", { params: { idevent, idsport } });
  return response.data;
};

export const saveUniformMatrix = async ({ idevent, idsport, items, removed }) => {
  const response = await httpService.put("/uniforms/matrix", { idevent, idsport, items, removed });
  return response.data;
};
